import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
	noDecoration: {
		textDecoration: "none",
		color: "var(--typography-link-font-color)"
	}
});
